import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const save = async (accessLevels) => {
  try {
    const result = await fetch(`${hostName}/business/team-access-level`, {
      method: "PUT",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(accessLevels),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
